import React from 'react';
import { Switch } from 'react-router-dom';
import { RestrictedRoute } from 'modules/Auth/components';
import * as permissions from 'modules/Core/domain/permissions';
import { InstrumentListPage, InstrumentPage } from '../containers';

const InstrumentManagementRouter = () => (
  <Switch>
    <RestrictedRoute
      exact
      path="/instruments/management/:instrumentId"
      permission={permissions.LDX_INSTRUMENT_REPAIR_VIEW}
      component={InstrumentPage}
    />
    <RestrictedRoute
      exact
      path="/instruments/management"
      permission={permissions.LDX_INSTRUMENT_REPAIR_VIEW}
      component={InstrumentListPage}
    />
  </Switch>
);

export default InstrumentManagementRouter;
